/**
 * @generated SignedSource<<a77e14d49fbbf3d7d8803c273abf3b6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type openQuestionsSeriesPlusArchiveQuery$data = {
  readonly plusArchiveOpenQuestionsSeries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"hooksPlusArticleLinkHandlerArticle" | "plusPrimaryContentItemContent">;
      };
    }>;
  };
  readonly " $fragmentType": "openQuestionsSeriesPlusArchiveQuery";
};
export type openQuestionsSeriesPlusArchiveQuery$key = {
  readonly " $data"?: openQuestionsSeriesPlusArchiveQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"openQuestionsSeriesPlusArchiveQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "openQuestionsSeriesTypeUuid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "openQuestionsSeriesPlusArchiveQuery",
  "selections": [
    {
      "alias": "plusArchiveOpenQuestionsSeries",
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "topicIds.0",
                  "variableName": "openQuestionsSeriesTypeUuid"
                }
              ],
              "kind": "ListValue",
              "name": "topicIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 4
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ContentConnection",
      "kind": "LinkedField",
      "name": "contents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "plusPrimaryContentItemContent"
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "hooksPlusArticleLinkHandlerArticle",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersCheckCanShowInPlusPlatformContent",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckArticleIsInSectionsArticle",
                          "selections": (v2/*: any*/),
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckIsPlusArticle",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PaywallType",
                                  "kind": "LinkedField",
                                  "name": "paywallTypes",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "entityUuid",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckIsStyleArticle",
                          "selections": (v2/*: any*/),
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersGetArticleTypeArticle",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ArticleTypeSegment",
                                  "kind": "LinkedField",
                                  "name": "types",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ArticleType",
                                      "kind": "LinkedField",
                                      "name": "value",
                                      "plural": true,
                                      "selections": (v1/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersUseContentSponsorContent",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Topic",
                              "kind": "LinkedField",
                              "name": "topics",
                              "plural": true,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Sponsor",
                                  "kind": "LinkedField",
                                  "name": "sponsor",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "args": null,
                                      "kind": "FragmentSpread",
                                      "name": "sponsorTagSponsor"
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "name",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "type",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "sponsorType",
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckIsMainTopicContent",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Topic",
                                  "kind": "LinkedField",
                                  "name": "topics",
                                  "plural": true,
                                  "selections": (v1/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urlAlias",
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "c93a7eca454daf5da6ebbd52f1d48602";

export default node;
